import React from 'react'
import { Link, useMatch } from 'react-router-dom'
import { formatNumber, makeMaterialTypeToolTip } from 'utils/helpers'
import getLinkCell from 'components/generic/datagrid/cells/LinkCell'
import { formatAddress } from 'utils/data-manipulation/valueFormatter'
import { Stack, Typography } from '@mui/material'

// This array should contain all possible fields a grid can have
export const contractOrderFields = isSales => {
  const contract = isSales ? 'sales' : 'purchase'
  const orderFields = [
    {
      field: 'contractOrderNumber',
      headerName: `${isSales ? 'S' : 'P'}O#`,
      flex: 1,
      renderCell: params => {
        const { id, readableId } = params.row
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const match = useMatch({
          path: `app/contracts/${contract}-orders`,
          end: true,
        })
        if (match) return getLinkCell(params, 'readableId')
        return (
          <Link to={`/app/contracts/${contract}-orders/${id}`} target="_blank">
            {readableId}
          </Link>
        )
      },
    },
    {
      field: 'customerOrderNumber',
      headerName: 'Cust Order #',
      flex: 1,
    },
    {
      field: 'effectiveDate',
      headerName: 'Eff. Date',
      flex: 1,
      sortComparator: (v1, v2) => new Date(v1) - new Date(v2),
    },
    {
      field: 'expirationDate',
      headerName: 'Exp. Date',
      flex: 1,
      sortComparator: (v1, v2) => new Date(v1) - new Date(v2),
    },
    {
      field: 'customerName',
      headerName: 'Customer',
      flex: 1,
    },
    ...(isSales
      ? [
          {
            field: 'freightDestination',
            headerName: 'Destination',
            renderCell: ({ row: { freightDestination } }) => (
              <Stack style={{ display: 'flex' }}>
                <Typography>{freightDestination?.locationName}</Typography>
                <Typography variant="subtitle2">{formatAddress(freightDestination)}</Typography>
              </Stack>
            ),
            flex: 1,
          },
        ]
      : []),
    {
      field: 'pickupDelivery',
      headerName: 'Pickup/Delivery',
      flex: 1,
    },
    {
      field: 'materials',
      headerName: 'Materials',
      flex: 1,
      sortable: false,
      renderCell: params => makeMaterialTypeToolTip(params.row.materials),
    },
    {
      field: 'price',
      headerName: 'Price',
      flex: 1,
      headerAlign: 'right',
      align: 'right',
      renderCell: params => (params?.row?.price === 'Mixed' ? 'Mixed' : formatNumber(`${params?.row?.price}`)),
    },
    {
      field: 'ordered',
      headerName: 'Ordered',
      headerAlign: 'right',
      align: 'right',
      renderCell: params => params?.row?.ordered,
      flex: 1,
    },
    {
      field: 'remain',
      headerName: 'Remain',
      headerAlign: 'right',
      align: 'right',
      renderCell: params => params?.row?.remain,
      flex: 1,
    },
    {
      field: 'fulfilled',
      headerName: 'Fulfilled',
      headerAlign: 'right',
      align: 'right',
      renderCell: params => params?.row?.fulfilled,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
    },
  ]

  return orderFields
}
